import React, { useState } from 'react';
import Login from '../components/Login';
import Register from '../components/Register';

const AuthPage = () => {
  // Siempre mostrar solo login, sin opción de registro
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center p-4" data-testid="auth-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img 
            src="/surnexa-logo.png" 
            alt="Surnexa Logo" 
            className="w-64 h-auto mx-auto mb-4"
          />
          <p className="text-blue-100">Sistema de gestión de trabajos de campo</p>
        </div>
        
        <Login showRegisterLink={false} />
      </div>
    </div>
  );
};

export default AuthPage;